
export enum DataSourcesEnum {
    ElectionDates = 'ElectionDates',
    HAStatic = 'HAStatic',
    HAChange = 'HAChange',
    LCStatic = 'LCStatic',
    LCChange = 'LCChange',
    LGEStatic = 'LGEStatic',
    LGEChange = 'LGEChange'
}